import i18next from "i18next";
import { initReactI18next } from "react-i18next";
import HttpApi from "i18next-http-backend";
import LanguageDetector from "i18next-browser-languagedetector";

i18next
  .use(HttpApi)
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {},
    supportedLngs: ["en", "is"],
    fallbackLng: "en",
    debug: false,
    detection: {
      order: ["cookie", "path", "localStorage", "htmlTag"],
      caches: ["cookie"],
    },
    react: { useSuspense: false },
  });

export default i18next;
